import React, { Component } from 'react';
import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
// import './style.scss';

@inject('lineStore')
@observer
class FavouriteStar extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
    }
    
    toggle(e) {
        if (this.props.disabled && this.props.lineStore.menu.favourites.games.length > 0) {
            this.props.lineStore.menu.selectItem('fav', 0);
        } else {
            this.props.lineStore.menu.toggleFav(this.props.id, this.props.type);
        }
    }
    
    render() {

        if (!this.props.lineStore.menu) return false;

        let on = false;
        const { favourites } = this.props.lineStore.menu; 



        const id = Number(this.props.id);
    
        switch (this.props.type) {
            case 0:
                on = favourites.games.length > 0 || favourites.popular.pop.length ? true : false;
                break;
            case 1:
                on = favourites.sport.indexOf(id) != -1 ? true : false;
                break;
            case 2:
                on = favourites.league.indexOf(id) != -1  ? true : false;
                break;
            case 3:
                on = favourites.games.indexOf(id) != -1 ? true : false;
                break;
            case 4:
                on = favourites.popular.pop.indexOf(id) != -1 ? true : false;
                break;
        }
        return <button href="#" onClick={this.toggle} className={classNames(['favourites-star f-s-ico-fav', {'on': on}])} >&nbsp;</button>;
    }
}

export default FavouriteStar;


// WEBPACK FOOTER //
// ./src/components/favouriteStar/index.jsx